export default __webpack_public_path__ + "static/footer-pattern-efe55c352e9122e40b8f265dfe714cb9.svg";